import React from "react";
import Select from "react-select";

const FiltersCandidato = ({
  listCandidatos,
  listUbicacion,
  currentUbicacion,
  setCurrentUbicacion,
  handleCandidato,
}) => {
  return (
    <div className="row filters no-gutters p-0">
      <div className="col-md-8 pr-1">
        <Select
          options={listCandidatos}
          placeholder={"Candidato"}
          onChange={handleCandidato}
        />
      </div>
      <div className="col-md-4 pr-1">
        <Select
           id="region"
           value={currentUbicacion.region ? ({label: currentUbicacion.region, value: currentUbicacion.region}) : null}
          options={[{ value: "Todos", label: "--Todos--" },...[...new Set(listUbicacion.map((a) => a.region))].map(
            (region) => {
              let item = listUbicacion.find((a) => a.region === region);
              return { value: item.region, label: item.region };
            }
          )]}
          placeholder={"Región"}
          onChange={(option) =>
            setCurrentUbicacion({
              ...currentUbicacion,
              region: option.value
            })
          }
        />
      </div>
     
      
    </div>
  );
};

export default FiltersCandidato;
